export default __webpack_public_path__ + "static/included-1-abd4a56d1fbecefdd26d1c3984ad15a0.png";